define([
	'internal_util/Logger',
	'internal_util/Util',
	'internal_util/XMLUtil',
	'model/Attribute',
	'model/Origin',
	'lib/jquery',
	
	'model/bindings/PasswordBindingType',
	'model/bindings/WebCryptoKeyBindingType',
	'model/bindings/FidoU2FBindingType'
], function (
		Logger,
		Util,
		XMLUtil,
		Attribute,
		Origin,
		jQuery,
		
		PasswordBindingType,
		WebCryptoKeyBindingType,
		FidoU2FBindingType
		) {
	'use strict';

	/**
	 * BindingsFactory class
	 */
	return new function () {
		//TODO: logging
		this.createPasswordBinding = function (secret, salt) {
			return new PasswordBindingType(secret,salt);
		};
		
		this.createWebCryptoKeyBindingType = function (secret, salt, keyId) {
			return new WebCryptoKeyBindingType(secret, salt, keyId);
		};
		
		this.createFidoU2F = function (data, nonce, pvr, salt) {
			return new FidoU2FBindingType(data, nonce, pvr, salt);
		};
		
		this.createFromObject = function (bindings) {
			if (!Util.isArray(bindings)) {
				var tmp =  bindings;
				bindings = new Array();
				bindings.push(tmp);
			}

			var bindingTypes = new Array();
			
			for (var b in bindings) {
				switch(bindings[b]["type"]) {
					case "http://ws.skidentity.de/ci/binding/password/v1.0":
						bindingTypes.push(new PasswordBindingType(bindings[b]["secret"] ? bindings[b]["secret"] : null, 
																	bindings[b]["salt"]));
						break;
					case "http://ws.skidentity.de/ci/binding/key/v1.0":
						switch(bindings[b]["origin"]) {
							case "WebCrypto":
								bindingTypes.push(new WebCryptoKeyBindingType(bindings[b]["secret"] ? bindings[b]["secret"] : null, 
																		bindings[b]["salt"], bindings[b]["keyId"]));
								break;
							case "FIDO/U2F":
								bindingTypes.push(new FidoU2FBindingType(bindings[b]["registrationData"], null, null, bindings[b]["salt"]));
								break;
						}
						break;
				}
			}

			return bindingTypes;
		};
		
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/factory/BindingsFactory.js
// module id = 47
// module chunks = 7